import useSWR from "swr";

import SWR_KEYS from "@/constants/swr-keys";
import { IWorkflowStep } from "@/interfaces/workflow-step.interface";
import workflowStepService from "@/services/workflow-steps";
import { ByIdRequestProps, RequestsBaseReturn } from "@/types/requests.types";

export type UseGetWorkflowStepByIdReturn = RequestsBaseReturn<IWorkflowStep | null>;

export type UseGetWorkflowStepByIdProps = ByIdRequestProps;

type UseSwrGetWorkflowStepByIdParams = [string, number] | null;

const useGetWorkflowStepById = ({
  _id,
}: UseGetWorkflowStepByIdProps): UseGetWorkflowStepByIdReturn => {
  const {
    data = null,
    isValidating: isLoading,
    error,
  } = useSWR<IWorkflowStep, Error, UseSwrGetWorkflowStepByIdParams>(
    _id ? [SWR_KEYS.getWorkflowStepById, _id] : null,
    ([, workflowStepId]) => workflowStepService.getById(workflowStepId),
    {
      revalidateOnFocus: false,
    }
  );

  return { data, isLoading, error };
};

export default useGetWorkflowStepById;
